<template>
    <div>
        <rkm-area
            title="Problemas e/ou condições avaliados neste atendimento"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-checkbox-group
                        name="Condição avaliada"
                        v-model="data.model.condicoesAvaliadas"
                    >
                        <rkm-form-checkbox
                            v-for="condicao in data.form.problemaCondicao.condicoesAvaliadas"
                            :disabled="readonly || disableCondicao(condicao.id)"
                            :key="condicao.id"
                            :value="condicao.id"
                            class="w-25 m-0"
                        >
                            {{ condicao.descricao }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-area
                        no-margin-top
                        title="Doenças transmissíveis"
                    >
                        <rkm-row>
                            <rkm-col cols="12">
                                <rkm-form-checkbox-group
                                    name="Doenças transmissíveis"
                                    v-model="data.model.doencasTransmissiveis"
                                >
                                    <rkm-form-checkbox
                                        v-for="doencao in data.form.problemaCondicao.doencasTransmissiveis"
                                        :disabled="readonly"
                                        :key="doencao.id"
                                        :value="doencao.id"
                                        class="w-25 m-0"
                                    >
                                        {{ doencao.descricao }}
                                    </rkm-form-checkbox>
                                </rkm-form-checkbox-group>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-area
                        no-margin-top
                        title="Rastreamentos"
                    >
                        <rkm-row>
                            <rkm-col cols="12">
                                <rkm-form-checkbox-group
                                    name="Rastreamento"
                                    v-model="data.model.rastreamentos"
                                >
                                    <rkm-form-checkbox
                                        v-for="rastreamento in data.form.problemaCondicao.rastreamentos"
                                        :disabled="readonly || disableRastreamento(rastreamento.id)"
                                        :key="rastreamento.id"
                                        :value="rastreamento.id"
                                        class="w-25 m-0"
                                    >
                                        {{ rastreamento.descricao }}
                                    </rkm-form-checkbox>
                                </rkm-form-checkbox-group>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-area
                        no-margin-top
                        title="Outros"
                    >
                        <template
                            v-if="!readonly"
                            slot="trailing"
                        >
                            <rkm-button
                                @click="$refs.Modal.open()"
                                color="primary"
                                small
                                title="Adicionar"
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </template>

                        <rkm-row>
                            <rkm-col cols="12">
                                <List
                                    :data="data"
                                    :readonly="readonly"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <Modal
            :data="data"
            @store="handleStore"
            ref="Modal"
        />

        <ModalOci
            :data="data"
            ref="ModalOci"
        />
    </div>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'
import ModalOci from './components/oci/Modal'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'
import condicaoAvaliada from '@/enums/atencao-basica/atendimento-individual/condicaoAvaliada'
import rastreamento from '@/enums/atencao-basica/atendimento-individual/rastreamento'

export default {
    components: {
        List,
        Modal,
        ModalOci,
    },
    created() {

        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
        }
    },
    data: () => ({
        enums: {
            sexo,
            condicaoAvaliada,
            rastreamento,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        disableCondicao(condicaoId) {

            return ((condicaoId == this.enums.condicaoAvaliada.PRE_NATAL || condicaoId == this.enums.condicaoAvaliada.PUERPERIO)
                && this.data.additionals.paciente.sexoId == this.enums.sexo.MASCULINO) || condicaoId == this.enums.condicaoAvaliada.REABILITACAO
        },
        disableRastreamento(rastreamentoId) {

            return rastreamentoId == this.enums.rastreamento.CANCER_COLO_UTERO
                && this.data.additionals.paciente.sexoId == this.enums.sexo.MASCULINO
        },
        handleStore(data) {

            if (!this.data.additionals.isDemandaEspontanea && !this.data.ociModel.oci && data.cid) {

                this.setLoading()

                this.repositories.atendimento.list({
                    origem: 'avaliacao',
                    listar: 'ocis',
                    cid_id: data.cid.id,
                })
                    .then(response => {

                        if (response.data.length > 0) {

                            this.$refs.ModalOci.open(response.data)
                        }
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        }
    },
    mixins: [repository, error],
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, default: false},
    },
}
</script>